import { StyleSheet } from 'react-native';
import { Easing } from 'react-native-reanimated';
import { textLatoStyleDS } from 'src/theme-v2/text';
import { neutrals } from 'src/theme/colors';

export const NUMBER_HEIGHT = 18;
export const ANIMATION_DURATION = 250;
export const TIMING_CONFIG = { duration: ANIMATION_DURATION, easing: Easing.inOut(Easing.ease) };

export const styles = StyleSheet.create({
  container: {
    backgroundColor: neutrals.neutralGrays.cement,
    borderRadius: 999,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 10,
  },
  text: {
    color: neutrals.white,
    ...textLatoStyleDS.BodyBoldSm,
  },
  textRegular: {
    color: neutrals.white,
    ...textLatoStyleDS.BodyRegularSm,
  },
  separator: {
    color: neutrals.white,
    ...textLatoStyleDS.BodyRegularSm,
  },
  numberContainer: {
    overflow: 'hidden',
    height: NUMBER_HEIGHT,
  },
});
